import React, { useState, useEffect } from 'react'
import { Row, Col, Container, Card, Button, Modal, Form } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import Stepper from '../../component/stepper/Stepper';
import { pythonAxiosInstance } from '../../config/ConfigInfo';

import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import ChangeTemplateLayout from '../../component/changetemplate/ChangeTemplateLayout';

import PreviewTemplate from '../../component/preview/PreviewTemplate';
import { getItem, setItem } from '../../config/localStorage';

import SpinLoader from '../../component/loader/SpinLoader';

function Skills() {
    const jobTitle = getItem('jobTitle');
    const saveRating = JSON.parse(getItem('rating'));
    const saveRatingItem = getItem('ratingItem');
    const countItem = (saveRatingItem != null) ? (saveRatingItem.split('</p>').length - 1) : 0;

    const [tipsModalShow, setTipsModalShow] = useState(false);
    const [skillTabOne, setskillTabOne] = useState(true);
    const [skillTabTwo, setskillTabTwo] = useState(false);

    const [displaySkillsInEditor, setDisplaySkillsInEditor] = useState(saveRatingItem !== '' ? saveRatingItem : '');
    const [tabEditorShowhide, setTabEditorShowhide] = useState('textEditor');

    const [lineCount, setLineCount] = useState(countItem ? countItem : 0);

    const ratings = [];

    const [ratingData, setRatingData] = useState(saveRating !== '' ? saveRating : []);

    const [loader, setLoader] = useState(true);
    const [error, setError] = useState('');
    const [skillValidation, setSkillValidation] = useState('');

    const navigate = useNavigate();
    const location = useLocation();

    const [skillsList, setSkillsList] = useState([]);

    const [searchInput, setSearchInput] = useState('');

    const [progress, setProgress] = useState(15);
    const [searchToggle, setSearchToggle] = useState(false)


    /** to handle next and previous click button start */

    const backEducationPage = () => {
        navigate('/education', { state: { educationTabThree: true } });
    }

    const MovetoSummaryPage = () => {
        if (lineCount === 0) {
            setSkillValidation('It’s recommended to add skills to improve your resume');
        } else {
            navigate('/summary', { state: { summaryFieldsOne: true } });
        }
    }

    useEffect(() => {

        if (location.state === null) {
            navigate('/resume-builder');
        } else {
            if (location.state.skillFieldsOne === true) {
                skillFieldsOne();
            }
            if (location.state.skillFieldsTwo === true) {
                skillFieldsTwo();
            }
        }

    }, []);


    /** search functionality start */

    const handleSearch = (e) => {
        e.preventDefault();
        if (e.target.elements.searchSkill.value === '') {
            setError('Please enter a job title');
        } else {
            setSearchToggle(!searchToggle);
            setSearchInput(e.target.elements.searchSkill.value);
            setError('');
        }
    };

    /** search functionality end */


    /** call API to fetch the skills data start */

    useEffect(() => {

        (async () => {
            const raw = {
                job_title: searchInput === '' ? jobTitle : searchInput
            };
            try {
                setLoader(true);
                const response = await pythonAxiosInstance.post('generate-skills/', raw);
                if (response.status === 200 && response.data.skills_job_title.length > 0) {
                    let updatedSkills;
                    if (saveRating) {
                        updatedSkills = response.data.skills_job_title.map((list) => {
                            const match = saveRating?.find((item) => item.name === list.name);
                            if (match) {
                                return { ...list, disabled: true };
                            }
                            return list;
                        });
                    } else {
                        updatedSkills = response.data.skills_job_title;
                    }
                    setLoader(false);
                    setSkillsList(updatedSkills);
                    setError('');
                }
            } catch (error) {
                setError(error.message);
                setLoader(false);
            }
        })()

    }, [searchInput, searchToggle]);

    /** call API to fetch the skills data end */


    /** to handle next and previous click button end    */

    const skillFieldsOne = (e) => {
        setskillTabOne(true);
        setskillTabTwo(false);
    }

    const skillFieldsTwo = (e) => {
        setskillTabOne(false);
        setskillTabTwo(true);
    }

    const skilTabShowHide = (tabshow) => {
        setTabEditorShowhide(tabshow);
    }

    const editorConfiguration = {
        ui: {
            poweredBy: {
                forceVisible: true
            }
        },
        toolbar: [
            'bold',
            'italic',
        ],
        toolarLocation: 'bottom',
        placeholder: 'Add your skills here. For the add new skill please go with enter keyword!'
    };

    const handleSkillListClick = (itemName) => {
        const appendSkill = displaySkillsInEditor ? displaySkillsInEditor + '<p>' + itemName + '</p>' : '<p>' + itemName + '</p>';
        setDisplaySkillsInEditor(appendSkill);
        setItem('ratingItem', appendSkill);

        setSkillValidation('');

        const updatedSkillsList = skillsList.map(skill =>
            skill.name === itemName ? { ...skill, disabled: true } : skill
        );
        setSkillsList(updatedSkillsList);
        setLineCount(lineCount + 1);
        
    }

    /* get the skill data start */
    const handleEditorChange = (event, editor) => {
        const data = editor.getData();
        setDisplaySkillsInEditor(data);
        setItem('ratingItem', data);

        setSkillValidation('');

        let inputTextData = data.split('<p>').map(item => item.replace('</p>', ''));
        inputTextData.shift();

        const changedItems = compareDataAndSkills(inputTextData, skillsList)
        setSkillsList(changedItems);

        /** to get the count after enter the data in editor */
        const pTagsCount = data.split('</p>').length - 1;
        setLineCount(pTagsCount);
    };

    function compareDataAndSkills(data, Skills) {
        const result = [];
        Skills.forEach(item => {
            const foundItem = data.includes(item.name);
            const newItem = { ...item, disabled: foundItem };
            result.push(newItem);
        });
        return result;
    }

    /* get the skill data end */

    /* star rating code start */

    const ratingArray = displaySkillsInEditor != null ? displaySkillsInEditor.split('</p><p>').map((str) => str.replace(/<[^>]*>/g, '')) : [];
    const newRatingArray = ratingArray.map(item => item.replace(/&nbsp;/g, ''));

    const combinedData = newRatingArray.map((name) => {
        const existingRating = saveRating?.find((item) => item.name === name);
        return {
            name,
            rating: existingRating ? existingRating.rating : 0,
        };
    });

    const ratingsList = ratings.concat(...combinedData);

    useEffect(() => {
        setItem('rating', JSON.stringify(ratingsList));
        setRatingData(ratingsList);
        setProgress(lineCount * 6.66) // display percentage as per 10 skills data.
    }, [displaySkillsInEditor])

    const handleRating = (skillIndex, starIndex) => {
        const newSkills = ratingData.map((skill, index) => {
            if (index === skillIndex) {
                return { ...skill, rating: starIndex + 1 };
            }
            return skill;
        });
        setRatingData(newSkills);
        setItem('rating', JSON.stringify(newSkills));
    };

    /* star rating code end*/

    /* Calculate the color dynamically based on progress start */

    const getColor = () => {

        if (progress < 100) {

            return '#1da425'; // Change to your desired color

        } else {

            return 'red'; // Change to another color

        }

    };

    /* Calculate the color dynamically based on progress start */

    return (
        <>
            <section className='main-section padding-top-bottom skill-main-section'>
                <Container>
                    <Row>
                        <Col md={12}>
                            <Card className='skill-card-option shadow border-0'>
                                
                                <Stepper pagenumber='4' />
                                {
                                    skillTabOne ?
                                        < Card.Body className='skill-part-one-main'>
                                            <Row>
                                                <Col md={9} className='skill-part-one-text-outer'>
                                                    <div className='skill-part-one-text'>
                                                        <h2>Skills</h2>
                                                        <p>Identify key skills that you possess and that are relevant to your desired job. Include both hard and soft skills, and make sure to align them with the job description to enhance your candidacy.</p>
                                                        </div>
                                                </Col>
                                                <Col md={3}>
                                                    <ChangeTemplateLayout />
                                                </Col>
                                                <Col md={12}>
                                                    <Col className='next-prev-btn-section col-md-12'>
                                                        <Row>
                                                            <Col md={12} className='form-mid-section'>
                                                                <Button className='my-previous-btn float-start' onClick={backEducationPage} >Back</Button>
                                                                <PreviewTemplate />
                                                                <Button className='my-next-btn button-green float-end' onClick={skillFieldsTwo}>Next</Button>
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                </Col>
                                            </Row>
                                        </Card.Body>
                                        : ''
                                }

                                {
                                    skillTabTwo ?
                                        <Card.Body className='skill-part-two-main'>
                                            <Row>
                                                <Col md={12} className='skill-part-two-text-outer'>
                                                    <div className='skill-part-two-text'>
                                                        <h2>What Skills would you like to highlight?</h2>
                                                        <p>Choose from our pre-written examples below or write your own.</p>
                                                        <div className='tool-tip'>
                                                            <div onClick={() => setTipsModalShow(true)}>
                                                                <div className='tool-tip-inner'>
                                                                    <i className="fa fa-lightbulb-o"></i> <span>Tips</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Col>

                                                <Col md={12} className='mt-3 mb-3 skill-ai-page'>
                                                    <Row>
                                                        <Col md={6} className='mb-3'>
                                                            <Col md={12} className='skill-left-section'>
                                                                <h6 className='text-center mt-2'>Search By Job Title For Pre-Written Examples</h6>
                                                                <Col md={12} className='ai-search-skill-form'>
                                                                    <Form onSubmit={handleSearch}>

                                                                        <div className='ai-serach-form-section'>

                                                                            <div className='input-section'>

                                                                                <Form.Control

                                                                                    placeholder="Search By Job Title"

                                                                                    size="lg"

                                                                                    type='text'

                                                                                    id="searchSkill"

                                                                                />

                                                                            </div>

                                                                            <div className='button-section'>

                                                                                <button type="submit" className='search-skill-btn'><i className="fa fa-search"></i></button>

                                                                            </div>

                                                                        </div>

                                                                    </Form>

                                                                    {

                                                                        error ?

                                                                            <Col md={12} className='mt-3 d-inline-block w-100'>

                                                                                <div className="alert alert-danger" role="alert">

                                                                                    {error}

                                                                                </div>

                                                                            </Col> : ''

                                                                    }
                                                                </Col>
                                                                <Col md={12} className='mt-3 ai-search-skill-result-part'>
                                                                    <Card>
                                                                        <Card.Body>
                                                                            <Card.Title>Ready-to-use-examples</Card.Title>
                                                                            <div className='ai-list-item'>

                                                                                <ul className='text-center'>
                                                                                    {

                                                                                        loader === true ? <SpinLoader /> :
                                                                                            skillsList.map((item, index) => (
                                                                                                <li key={item.id} item={item.name} >
                                                                                                    <div className='button-part'>
                                                                                                        <Button onClick={() => handleSkillListClick(item.name)} disabled={item.disabled}>
                                                                                                            <i className="fa fa-plus" aria-hidden="true"></i>
                                                                                                        </Button>
                                                                                                    </div>
                                                                                                    <div className='text-part source-editor-1'>
                                                                                                        <h5>{item.name}</h5>
                                                                                                    </div>
                                                                                                </li>
                                                                                            ))

                                                                                    }
                                                                                </ul>
                                                                            </div>
                                                                        </Card.Body>
                                                                    </Card>
                                                                </Col>
                                                            </Col>
                                                        </Col>
                                                        <Col md={6} className='mb-3'> .
                                                            <Col md={12} className='skill-right-section'>

                                                                <div className='skill-right-heading-tab'>
                                                                    <ul>
                                                                        <li className={`text-editor-tab ${tabEditorShowhide === 'textEditor' ? 'active' : ''}`} onClick={(e) => skilTabShowHide('textEditor')}>Step 1 (Text Editor)</li>
                                                                        <li className={`skill-rating-tab ${tabEditorShowhide === 'ratingEditor' ? 'active' : ''}`} onClick={(e) => skilTabShowHide('ratingEditor')}>Step 2 (Skills Rating)</li>
                                                                    </ul>
                                                                </div>

                                                                <div className='skill-right-content-part'>
                                                                    {
                                                                        tabEditorShowhide === 'textEditor' ?
                                                                            <div className='destination-text-editor'>
                                                                                <h5>Add Skills:</h5>
                                                                                <CKEditor
                                                                                    editor={ClassicEditor}
                                                                                    data={displaySkillsInEditor}
                                                                                    config={editorConfiguration}
                                                                                    onChange={handleEditorChange}
                                                                                />
                                                                            </div>
                                                                            :
                                                                            <>
                                                                                <div className='destination-editor-skills-rating'>
                                                                                    <h5>Skills Rating:</h5>
                                                                                    <div className='skill-rating-section'>
                                                                                        {
                                                                                            lineCount > '0' ?
                                                                                                ratingData?.map((skill, skillIndex) => (
                                                                                                    <div key={skillIndex} className="skill-list-item">

                                                                                                        <div className='rating-section'>
                                                                                                            {
                                                                                                                [...Array(5)].map((star, starIndex) => (
                                                                                                                    <span
                                                                                                                        key={starIndex}
                                                                                                                        className="star"
                                                                                                                        style={{
                                                                                                                            cursor: 'pointer',
                                                                                                                            color: starIndex < skill.rating ? 'gold' : 'gray',
                                                                                                                        }}
                                                                                                                        onClick={() => handleRating(skillIndex, starIndex)}
                                                                                                                    >
                                                                                                                        ★
                                                                                                                    </span>
                                                                                                                ))
                                                                                                            }
                                                                                                        </div>
                                                                                                        <div className='rating-item-section'>
                                                                                                            <span>{skill.name}</span>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                ))
                                                                                                : 'Please add the skill in the text editor tab and click enter keyword to add more new skills.'
                                                                                        }
                                                                                    </div>
                                                                                </div>
                                                                            </>
                                                                    }

                                                                    <div className='d-flex align-items-center mt-3'>
                                                                        <p className='mb-1'>Skills : {lineCount}</p>
                                                                        <div className='ms-auto question-info position-relative'>
                                                                            <i className='fa fa-circle-question text-primary' />
                                                                            <div className='showcustom'>
                                                                                <i className='fa fa-circle-info w-100 text-center mb-2 text-primary'></i>
                                                                                <h6 className='text-center'>For the best impact, we recommend listing 10 to 12 skills relevant to your target job</h6>
                                                                                <ul>
                                                                                    <li>Add skills relevant to your target job.</li>
                                                                                    <li>Preview your resume to ensure there are no gaps between columns.</li>
                                                                                    <li>Skills will be displayed according to your chosen template layout.</li>
                                                                                    <li>Only the top 15 skills will be shown in the final resume template.</li>
                                                                                </ul>
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                    <div className="progress customize-progress">
                                                                        <div
                                                                            className="progress-bar"
                                                                            role="progressbar"
                                                                            style={{
                                                                                width: `${progress}%`,
                                                                                backgroundColor: getColor(),
                                                                            }}
                                                                            aria-valuenow={progress}
                                                                            aria-valuemin={10}
                                                                            aria-valuemax={100}
                                                                        />
                                                                    </div>

                                                                    {
                                                                        lineCount > 15 ?
                                                                            <div className="alert alert-danger mt-3" role="alert">
                                                                                It looks like you've added more than 15 skills. We recommend keeping your profile concise and impactful by including 10-12 skills
                                                                            </div>
                                                                            : ''
                                                                    }

                                                                </div>

                                                            </Col>
                                                            {
                                                                skillValidation ? <div className="alert alert-danger mt-3" role="alert">{skillValidation}</div> : ''
                                                            }
                                                        </Col>
                                                    </Row>
                                                </Col>

                                                <Col md={12}>
                                                    <Col className='next-prev-btn-section col-md-12'>
                                                        <Row>
                                                            <Col md={12} className='form-mid-section'>
                                                                <Button className='my-previous-btn float-start' onClick={skillFieldsOne}>Back</Button>
                                                                <Button className='my-next-btn button-green float-end' onClick={MovetoSummaryPage}>Next</Button>
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                </Col>
                                            </Row>
                                        </Card.Body>
                                        : ''
                                }

                            </Card>
                        </Col>
                    </Row>
                </Container >
            </section >

            <SkillsTipsModal
                show={tipsModalShow}
                onHide={() => setTipsModalShow(false)}
            />
        </>
    )
}

function SkillsTipsModal(props) {
    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Skills Tips
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className='skils-tips-section'>
                    <p><strong>Relevance is Key:</strong></p>
                    <ul>
                        <li>Focus on skills that are directly related to the job you’re applying for. Review the job description and prioritize the skills mentioned by the employer. This shows you’re a good fit for the role.</li>
                    </ul>
                </div>
                <div className='skils-tips-section'>
                    <p><strong>Categorize Your Skills:</strong></p>
                    <ul>
                        <li>Divide your skills into sections such as "Technical Skills," "Soft Skills," and "Language Skills." This makes it easier for the employer to quickly find the information they’re looking for.</li>
                    </ul>
                </div>
                <div className='skils-tips-section'>
                    <p><strong>Use Action Words:</strong></p>
                    <ul>
                        <li>When describing your skills, use action verbs to add impact. For example, instead of just listing "Communication," you can say "Effective verbal and written communication."</li>
                    </ul>
                </div>
                <div className='skils-tips-section'>
                    <p><strong>Provide Evidence:</strong></p>
                    <ul>
                        <li>Whenever possible, back up your skills with examples. If you claim to have strong organizational skills, you might mention a specific project where you demonstrated this ability.</li>
                    </ul>
                </div>
                <div className='skils-tips-section'>
                    <p><strong>Keep it Updated:</strong></p>
                    <ul>
                        <li>Regularly update your skills section to reflect new abilities and knowledge you’ve acquired. This is especially important in fields that evolve rapidly, such as technology or marketing.</li>
                    </ul>
                </div>
            </Modal.Body>
        </Modal>
    );
}

export default Skills
